// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:940px){.assistant[data-v-34ded5be]{grid-gap:20px;display:grid;grid-template-areas:\"content image\";grid-template-columns:1fr 200px}.assistant-content[data-v-34ded5be]{grid-area:content}.assistant-image[data-v-34ded5be]{display:initial;grid-area:image;padding:55px 0 0}.assistant-image__image[data-v-34ded5be]{height:140px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
